import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { getMessage } from '@gef-ui/localization/messages';

import Panel from 'components/molecules/Panel';
import PAGES from 'constants/pages';

const Error = ({ children }) => {
	useEffect(() => {
		document.title = getMessage('common:gkcl902');
	}, []);

	return <Panel screenId={PAGES.wrappersAndFallbacks.error.id}>{children}</Panel>;
};

Error.propTypes = {
	children: PropTypes.node,
};

export default Error;
